import { createSlice } from "@reduxjs/toolkit";

type InitialState = {
    value: {
        accessToken: string;
        refreshToken: string;
        UID: string;
    }
};

const initialState = {
    value: {
        accessToken: '',
        refreshToken: '',
        UID: '',
    }
} as InitialState;

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken: (state, action) => {
            state.value.accessToken = action.payload;
        },
        setRefreshToken: (state, action) => {
            state.value.refreshToken = action.payload;
        },
        setUID: (state, action) => {
            state.value.UID = action.payload;
        },
    },
});

export const {
    setAccessToken,
    setRefreshToken,
    setUID,
} = authSlice.actions;
export default authSlice.reducer;